const Aksione = () => {
  return <div><h2>Actions Page Content</h2></div>;
};

export default Aksione;
